var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { ThemeProvider, ThemeContext } from 'styled-components';
import { isColorDark } from '../../color';
import { DEFAULT_THEME, getThemeVariant, } from '../../theme';
import { isFunction } from '../data';
export var BackgroundThemeProvider = function (_a) {
    var children = _a.children, rawBackgroundColor = _a.backgroundColor;
    var styledTheme = React.useContext(ThemeContext);
    var newProviderValue = React.useMemo(function () {
        var _a, _b;
        var currentTheme = styledTheme === null || styledTheme === void 0 ? void 0 : styledTheme.uiCore;
        var backgroundColor = isFunction(rawBackgroundColor)
            ? rawBackgroundColor(getThemeVariant({ theme: styledTheme }))
            : rawBackgroundColor;
        var newTheme = __assign(__assign({}, ((_a = currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.value) !== null && _a !== void 0 ? _a : DEFAULT_THEME)), { backgroundColor: backgroundColor, isDark: isColorDark(backgroundColor) });
        return {
            rootValue: (_b = currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.rootValue) !== null && _b !== void 0 ? _b : DEFAULT_THEME,
            value: newTheme,
        };
    }, [rawBackgroundColor, styledTheme]);
    var newStyledTheme = React.useMemo(function () { return (__assign(__assign({}, styledTheme), { uiCore: newProviderValue })); }, [newProviderValue, styledTheme]);
    return React.createElement(ThemeProvider, { theme: newStyledTheme }, children);
};
//# sourceMappingURL=BackgroundThemeProvider.js.map